// extracted by mini-css-extract-plugin
export default {"Main":"Main_Main__yjTqJ","Article":"Main_Article__cu-uN","Side":"Main_Side__oh8wH","First":"Main_First__tJBio","Second":"Main_Second__HlgE5","content":"Main_content__xCSZJ"};